
import request from '@/utils/request'

export default {
  getBookHomeColumnData() {
    return request({
      url: '/resource/getBookHomeColumnData',
      method: 'post'
    })
  },
  searchResourceByFirstLetter(data){
    return request({
      url: '/resource/searchResourceByFirstLetter',
      method: 'post',
      data
    })
  },
  getTopResourceDataByQueryEntity(data){
    return request({
      url: '/resource/getTopResourceDataByQueryEntity',
      method: 'post',
      data
    })
  },
  getResourceByLikeCategoryCode(data){
    return request({
      url: '/resource/getResourceByLikeCategoryCode',
      method: 'post',
      data
    })
  },
  getResourceByCategoryCodeAndResourceName(data){
    return request({
      url: '/resource/getResourceByCategoryCodeAndResourceName',
      method: 'post',
      data
    })
  },
  getHomeResourceByQueryEntity(data){
    return request({
      url: '/resource/getHomeResourceByQueryEntity',
      method: 'post',
      data
    })
  },

  updateStateByGuid(data){
    return request({
      url: '/resource/updateStateByGuid',
      method: 'post',
      data
    })
  },
  
}



// WEBPACK FOOTER //
// ./src/api/resource.js